import { QueryResult, useQuery } from '@apollo/client'
import { ExistingDevObjectivesToBeClosedInMeetingQuery, ExistingDevObjectivesToBeClosedInMeetingQueryVariables } from '../../types'
import { EXISTING_DEV_TARGETS_TO_BE_CLOSED } from './ObjectiveQuery'

export const useExistingDevTargetsToBeClosed = (
  meetingId: number,
): QueryResult<ExistingDevObjectivesToBeClosedInMeetingQuery, ExistingDevObjectivesToBeClosedInMeetingQueryVariables> => {
  return useQuery<ExistingDevObjectivesToBeClosedInMeetingQuery, ExistingDevObjectivesToBeClosedInMeetingQueryVariables>(
    EXISTING_DEV_TARGETS_TO_BE_CLOSED,
    {
      variables: { meetingId },
      fetchPolicy: 'network-only',
    },
  )
}
